const HEIC_MIME_TYPES = new Set(['image/heic', 'image/heif']);
const HEIC_EXTENSION_PATTERN = /\.hei[cf]$/i;

export const isHeicLikeFile = (file: File): boolean => {
  if (HEIC_MIME_TYPES.has(file.type)) {
    return true;
  }

  return HEIC_EXTENSION_PATTERN.test(file.name);
};

export async function convertHeicToJpeg(file: File): Promise<File> {
  const module = await import('heic2any');
  const heic2any = (module as { default?: unknown }).default ?? module;
  if (typeof heic2any !== 'function') {
    throw new Error('heic2any converter is unavailable');
  }

  const result = (await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.92
  })) as Blob | Blob[];

  const blob = Array.isArray(result) ? result[0] : result;
  if (!(blob instanceof Blob)) {
    throw new Error('HEIC conversion result is not a Blob');
  }

  const baseName = file.name.replace(/\.[^.]+$/, '') || 'image';
  const convertedName = `${baseName}.jpg`;

  return new File([blob], convertedName, {
    type: 'image/jpeg',
    lastModified: file.lastModified
  });
}
